import React from 'react';

import { UIText1, UIText2 } from '@cian/ui-kit';
import { IBuilderInfoModalContent } from '../../../../types';

import {
  formatNumberWithSpaces,
  formatPhoneNumber,
  transformNumToString,
  trimToDecimals,
} from '../../../../../common/utils';
import { ETestIds } from '../../../../constants';

import { Layout } from '../Layout';
import { PhoneButton } from './components/PhoneButton';

import styles from './styles.css';

interface IBankInfoModalContentProps {
  creditInfo: IBuilderInfoModalContent;
}

export const BuilderInfoModalContent: React.FC<IBankInfoModalContentProps> = ({ creditInfo }) => {
  const { offerName, offerDescription, iconPath, availableUntil, text, button, rate, monthlyPayment } = creditInfo;

  return (
    <Layout
      headerName={offerName}
      headerDescription={offerDescription}
      headerLogoUrl={iconPath}
      testId={ETestIds.BuilderModal}
      content={
        <>
          <ul className={styles['loan-details']}>
            <li>
              <UIText2 color={'text-secondary-default'}>Ставка</UIText2>
              <UIText1>{transformNumToString(trimToDecimals(Number(rate)))} %</UIText1>
            </li>
            <li>
              <UIText2 color={'text-secondary-default'}>Платеж</UIText2>
              <UIText1>от {formatNumberWithSpaces(monthlyPayment)} ₽</UIText1>
            </li>
          </ul>
          <UIText1>{availableUntil}</UIText1>
          <p className={styles['text']}>
            <UIText1>{text}</UIText1>
          </p>
        </>
      }
      button={<PhoneButton text={button.text} phone={formatPhoneNumber(button.phone)} />}
    />
  );
};

BuilderInfoModalContent.displayName = 'BuilderInfoModalContent';
